module.exports = __webpack_public_path__ + "static/media/p1_img1.08ddc016.png";